export default __webpack_public_path__ + "2b013fdd2977c316b5fb4158e09b7e42.svg";